import React from "react";
import "./Service.css";

/**
 * NOTE: I only changed the titles & paragraphs to match your images.
 * You can replace the image paths with your actual photos anytime.
 */
const services = [
  {
    // RETAINING WALLS (image 1)
    title: "Retaining Walls",
    paras: [
      "MNG Construction LLC has extensive experience in reinforced block retaining wall and rockery wall construction.",
      "Our teams deliver durable, engineered systems—from stepped gravity walls to reinforced MSE solutions—built with proper drainage, compaction, and geosynthetic reinforcement to ensure long-term stability."
    ],
    img: "./retaining.jpg",
    imgAlt: "Reinforced block retaining wall construction in progress",
    imageRight: true
  },

  

  {
    // REMOVE FISH BARRIERS
    title: "Remove Fish Barriers",
    paras: [
      "MNG Construction LLC has extensive experience in installing box culverts, realigning streams, setting up temporary stream diversion systems, and installing log jams—all within tight schedules such as weekend or short-term closures.",
      "From cofferdams and bypass pumping to in-water work windows and habitat features, we deliver compliant, constructible solutions that restore fish passage and improve stream function."
    ],
    img: "./constructionone.jpg",
    imgAlt: "Box culvert installation with stream realignment and diversion",
    imageRight: false
  },

  {
    // TRUCKING
    title: "Trucking",
    paras: [
      "MNG Construction LLC provides professional dump trucking services utilizing its dedicated fleet of trucks.",
      "Our experienced drivers support mass excavation, import/export, and material delivery with reliable dispatching, site-safe operations, and DOT-compliant equipment."
    ],
    img: "./truck.JPEG",
    imgAlt: "Dedicated dump trucks hauling and supporting site operations",
    imageRight: true
  },

  {
    // UNDERGROUND SERVICES
    title: "Underground Services",
    paras: [
      "MNG can handle the installation, repair, rehabilitation, and maintenance of all deep storm, sewer, and water pipelines, ranging from small 2-inch PVC to 120-inch corrugated metal.",
      "Our expertise covers most underground construction methods, including open-cut excavation and trench shoring. Whether installing gravity and force main pipelines, residential laterals, or other underground utility infrastructure, we deliver projects that communities depend on."
    ],
    img: "./underground.png",
    imgAlt: "Underground pipeline and utility construction operations",
    imageRight: false
  }
];

export default function Service() {
  return (
    <section className="services" aria-labelledby="services-title">
      <div className="services__container">
        <header className="services__header">
          <span className="services__eyebrow">MAKING IT HAPPEN</span>
          <h2 id="services-title" className="services__title">
            Our <span className="services__title-accent">Services</span>
          </h2>
          <p className="services__subtitle">
            Our services include bridges, roadways/freeways, street improvements, earthwork, site work/development,
            retaining walls, stream mitigation, channels, storm drains, box culverts, and underground utilities.
          </p>
        </header>

        <div className="services__grid">
          {services.map((service, index) => (
            <article
              key={`${service.title}-${index}`}
              className={`services__card ${
                service.imageRight ? "services__card--right" : "services__card--left"
              }`}
            >
              {/* Image */}
              <div className="services__image-container">
                <div className="services__image-wrapper">
                  <img
                    src={service.img}
                    alt={service.imgAlt}
                    className="services__image"
                    loading="lazy"
                  />
                  <div className="services__number">{`${(index + 1).toString().padStart(2, "0")}`}</div>
                </div>
              </div>

              {/* Content */}
              <div className="services__content-container">
                <div className="services__content-wrapper">
                  <h3 className="services__heading">
                    <span className="services__heading-line" aria-hidden="true"></span>
                    {service.title}
                  </h3>

                  {service.paras.map((p, i) => (
                    <p className="services__text" key={i}>
                      {p}
                    </p>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
